<div class="filters row">
    <div class="row">
        <div class="r-form-group">
            <label class="title">{{'LIDS.SEARCH' |translate}}</label>
            <input [(ngModel)]="freeSearch" type="text" pInputText size="50"
                placeholder="{{'BUSINESS_MANAGEMENT.FREE_SEARCH' |translate}}" (delayEvent)="filterfreeSearch()"
                delayEventName="onkeyup">
        </div>
    </div>
     <div class="r-form-group totalRecords">{{totalRecords}} {{'BUSINESS_MANAGEMENT.TITLE'|translate}}</div>
        <app-atn-export-excel [request]="request" [fileName]="'businesses'"></app-atn-export-excel>
    </div>
    <div class="table">
        <app-readonly-table #dt [columns]="columns" [selectionMode]="null" [itemsSource$]="businessRoulettes$"
            [isFilterable]="false" [paginator]="true" [scrollable]="true" (onLoadData)="onLoadData($event)" [isLoadLazy]="true"
            (sortChange)="onSort($event)" (onViewDetails)="OnViewBusinessDetails($event)"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="null">
        </app-readonly-table>
    </div>